@if (apConfig) {
  <div class="container-fluid mt-4 ps-4">
    <div class="row align-items-center justify-content-between">
      <div class="col">
        <h2 class="mb-4">Accounting - {{ apConfig.apSystem }}</h2>
      </div>
      @if (['Vantaca', 'Cinc'].includes(apConfig.apSystem ?? '')) {
        <div class="col-auto">
          <button
            class="btn btn-primary"
            [ngbTooltip]="syncAllVendorsTooltip"
            (click)="syncAllVendorsNow()"
          >
            Sync All Vendors
          </button>
          <ng-template #syncAllVendorsTooltip>
            Queues all linked vendors to be synced back to
            {{ apConfig.apDisplayName }}, pushing any updates that are needed
          </ng-template>
        </div>
      }
    </div>
    <div class="row">
      <div class="col-12 col-lg-4">
        <div class="row align-items-center justify-content-between">
          <div class="col-6">
            <label class="label">Display Name:</label>
          </div>
          <div class="col text-end">
            <p class="m-0">{{ apConfig.apDisplayName }}</p>
          </div>
        </div>
        <div class="row align-items-center justify-content-between">
          <div class="col-7">
            <label class="label">Next Vendor Sync:</label>
          </div>
          <div class="col text-end">
            <p class="m-0">{{ apConfig.nextVendorSync | date }}</p>
          </div>
        </div>
        <div class="row align-items-center justify-content-between">
          <div class="col-7">
            <label class="label">Last Vendor Sync:</label>
          </div>
          <div class="col text-end">
            <p class="m-0">{{ apConfig.lastVendorSync | date }}</p>
          </div>
        </div>
        <div class="row align-items-center justify-content-between">
          <div class="col-6">
            <label class="label">Sync Interval:</label>
          </div>
          <div class="col text-end">
            <p class="m-0">{{ apConfig.syncInterval }}</p>
          </div>
        </div>
        <div class="row align-items-center justify-content-between">
          <div class="col-6">
            <label class="label">Retry Interval:</label>
          </div>
          <div class="col text-end">
            <p class="m-0">{{ apConfig.retryInterval }}</p>
          </div>
        </div>
      </div>
      @if (apConfig.apSystem === 'Vantaca') {
        <div class="col-12 col-lg-5 ms-auto">
          <div class="alert alert-info mb-0">
            <strong>About Client Managed</strong>
            <p class="mb-1 mt-1">
              Marking a vendor as Client Managed using the
              <strong>+</strong> in the Actions column indicates you
              intentionally manage this vendor outside of the VIVE compliance
              workflow (your team handles this vendor internally). The vendor
              will be immediately removed from all compliance alerts and
              reminders.
            </p>
            <p class="mb-1">
              Removing the Client Managed flag using the
              <strong>-</strong> in the Actions column adds the vendor back into
              your alerts.
            </p>
            <hr class="my-2" />
            <strong>Sync All Vendors</strong>
            <p class="mb-0 mt-1">
              Use the <strong>Sync All Vendors</strong> button to immediately
              queue all linked vendors to be synced back to
              {{ apConfig.apDisplayName }} with the most up-to-date VIVE data.
            </p>
          </div>
        </div>
      }
    </div>
    <div class="row mb-3">
      <div class="col-12 pt-3 vh-100">
        <app-ap-vendors-grid
          [gridName]="'ClientApVendors'"
          [suppliedQueryData]="suppliedGridQueryData"
          [(reloadGridData)]="reloadGrid"
          [ColumnIdToColumnActions]="ColumnIdToColumnActions"
          [getCalculatedColumnActions]="calculatedColumnActions"
          [getCalculatedColumnTooltipMap]="calculateColumnTooltipMap"
          [defaultHiddenColumns]="defaultHiddenColumns"
          [suppressedColumns]="suppressedColumns"
          [suppressFieldDotNotation]="false"
          (actionEvent)="action($event)"
        ></app-ap-vendors-grid>
      </div>
    </div>
  </div>
}
